import "@/components/Portal/UserAccount/PersonalDetails/PersonalDetails.scss";

import { FCC } from "types";

import { PersonalData } from "@/components/Portal/UserAccount/PersonalDetails/PersonalData/PersonalData";

export const PersonalDetails: FCC = () => (
  <section id="personal-details">
    <PersonalData />
  </section>
);
